import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {BUTTON_THEME} from '@/constants/button';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';
import {ConfirmDialogActions} from './confirm-dialog';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonLabel?: string;
  confirmButtonTestId?: string;
  cancelButtonLabel?: string;
  cancelButtonTestId?: string;
};

// Generate default actions for confirm dialog
export const useConfirmDialogActions = ({
  onCancel,
  onConfirm,
  cancelButtonLabel,
  cancelButtonTestId,
  confirmButtonLabel,
  confirmButtonTestId,
}: Props) => {
  const {t} = useTranslation();

  return useMemo((): ConfirmDialogActions[] => {
    return [
      {
        label: cancelButtonLabel ?? t('components.confirm-dialog.cancel'),
        testId: cancelButtonTestId ?? 'confirm-dialog-cancel-button',
        type: 'cancel',
        trackingKey: WEB_CLICK_TRACKING_KEY.CANCEL_CONFIRMATION,
        theme: BUTTON_THEME.SECONDARY,
        onAction: onCancel,
      },
      {
        label: confirmButtonLabel ?? t('components.confirm-dialog.confirm'),
        testId: confirmButtonTestId ?? 'confirm-dialog-confirm-button',
        type: 'confirm',
        theme: BUTTON_THEME.PRIMARY,
        trackingKey: WEB_CLICK_TRACKING_KEY.CONFIRM_SAVE,
        onAction: onConfirm,
      },
    ];
  }, [cancelButtonLabel, cancelButtonTestId, confirmButtonLabel, confirmButtonTestId, onCancel, onConfirm, t]);
};
